import React from "react";

const NeueVerticalAlignCenterStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.19995 2.20001H13.8",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.19995 13.8H13.8",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.80005 9.00015V6.99999C3.80005 6.11634 4.51639 5.39999 5.40005 5.39999H10.6C11.4837 5.39999 12.2 6.11634 12.2 6.99999V9.00015C12.2 9.88383 11.4837 10.6002 10.6 10.6002H5.40005C4.51639 10.6002 3.80005 9.88383 3.80005 9.00015Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueVerticalAlignCenterStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;